import React from 'react';
import './Services.css';

interface Service {
  title: string;
  description: string;
  features: string[];
  icon: string;
}

const servicesData: Service[] = [
  {
    title: 'AI Agent Development',
    description: 'Design and deploy autonomous AI agents that intelligently interact, learn, and execute complex tasks in your business environment.',
    features: [
      'Custom agent architecture design',
      'Multi-agent orchestration systems',
      'RAG (Retrieval-Augmented Generation) integration',
      'Real-time decision-making capabilities'
    ],
    icon: '🤖'
  },
  {
    title: 'AI Strategy Consulting',
    description: 'Expert guidance to identify AI opportunities, create actionable roadmaps, and align AI initiatives with your business objectives.',
    features: [
      'AI readiness assessment',
      'Technology stack recommendations',
      'ROI analysis and business case development',
      'Implementation roadmap planning'
    ],
    icon: '🎯'
  },
  {
    title: 'Enterprise AI Solutions',
    description: 'End-to-end AI application development tailored to your industry, from proof-of-concept to production-ready systems.',
    features: [
      'Custom LLM fine-tuning and deployment',
      'Intelligent automation workflows',
      'Predictive analytics platforms',
      'Natural language processing systems'
    ],
    icon: '⚡'
  },
  {
    title: 'AI Integration & Implementation',
    description: 'Seamlessly integrate AI capabilities into your existing systems with minimal disruption and maximum efficiency.',
    features: [
      'API development and integration',
      'Legacy system AI enhancement',
      'Cloud-native AI deployment (Azure, AWS, GCP)',
      'Performance optimization and scaling'
    ],
    icon: '🔧'
  }
];

const Services: React.FC = () => {
  return (
    <section className="services" id="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive AI solutions tailored to your business needs
          </p>
        </div>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

